var spoiler_default = {
  "fontElementMap": "_9y7Mp",
  "hideText": "RFwaS",
  "onHoverText": "gv9K0",
  "hideBlock": "yTKlC",
  "smallBlur": "ELNEC",
  "mediumBlur": "VcnFQ",
  "largeBlur": "vtl4Y",
  "hideBlock_gallery": "_7xDkf",
  "overlay": "byaH2",
  "overlay_gallery": "_22EyI",
  "revealSpoilerBtn": "tyq68",
  "isMobile": "xOwF1",
  "onHoverBtn": "SUp9J",
  "spoilerWrapper": "KNAIB",
  "spoilerDescription": "_3FHQf",
  "spoilerContainer": "mqzMk",
  "spoilerContainer_Gallery": "Z5bTP"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
